import React from 'react';
import { DropdownWithIcon, DropdownItem } from 'seduo-ui';
export default class Example extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = () => {
            this.setState((prevState) => ({
                isOpen: !prevState.isOpen,
            }));
        };
        const items = [
            {
                id: 'first',
                value: 'First Action',
                isDefault: true,
            },
            {
                id: 'second',
                value: 'Second Action',
                isDefault: false,
            },
            {
                id: 'third',
                value: 'Third Action',
                isDefault: false,
            },
        ];
        this.state = {
            isOpen: false,
            selected: items[0],
            items,
        };
    }
    setFilter(item) {
        this.setState({
            selected: item,
        });
    }
    render() {
        const { isOpen, selected, items } = this.state;
        return (<DropdownWithIcon isOpen={isOpen} toggle={this.toggle} selected={selected.value} isDefaultSelected={selected.isDefault}>
                {items.map((item) => (<DropdownItem active={item === selected} key={item.id} onClick={() => this.setFilter(item)}>
                        {item.value}
                    </DropdownItem>))}
            </DropdownWithIcon>);
    }
}
